import { CAPTURE_SESSION_STATUSES, type CaptureSession, type LocalPhotoRef } from '@/shared/capture/capture-session';
import type { PhotoBlobRepository } from '@/shared/db/repositories/photo-blob-repository';

type PhotoBlobDeleter = Pick<PhotoBlobRepository, 'delete'>;

export async function deleteLocalPhotoBlobs(photoBlobs: PhotoBlobDeleter, photos: LocalPhotoRef[]) {
  const blobIds = new Set(
    photos.flatMap(photo =>
      photo.thumbnailBlobId && photo.thumbnailBlobId !== photo.localBlobId
        ? [photo.localBlobId, photo.thumbnailBlobId]
        : [photo.localBlobId],
    ),
  );

  for (const blobId of blobIds) {
    await photoBlobs.delete(blobId).catch(() => undefined);
  }
}

export async function cleanupSyncedSessionPhotoBlobs(photoBlobs: PhotoBlobDeleter, sessions: CaptureSession[]) {
  await deleteLocalPhotoBlobs(
    photoBlobs,
    sessions.filter(session => session.status === CAPTURE_SESSION_STATUSES.synced).flatMap(session => session.photos),
  );
}
